export default __webpack_public_path__ + "static/media/mos-coin.6a0ac38c.svg";